import React from 'react';
import _ from 'lodash';
import { object, number, string, bool, shape } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import GigCardListings from '@fiverr-private/gig_listings/src/entries/GigCardListings';
import CouponBomba from '../CouponBomba';

import './index.scss';

export default function Gigs({
    gigData,
    sellerName,
    sellerId,
    userId,
    currency,
    isTouch,
    pageCtxId,
    abTestsProps,
    collectProps,
    coupon
}) {

    const { gigs, gigCollect } = gigData;
    const context = {
        userId,
        currency,
        pageCtxId,
        abTestsProps,
        currentPage: 'user_page',
        sourcePage: 'user_page',
        viewportType: 'user_page.gigs',
        controllerAction: 'user_page#index'
    };

    const features = {
        gigInNewTab: true,
        priceFormatting: true
    };

    if (_.isEmpty(gigs)) {
        return false;
    }

    return (
        <section className="gigs-wrapper">
            <header>
                <h2 className="text-display-5"><I18n k="user_page_perseus.users_gigs" params={{ sellerName }}/></h2>
            </header>
            {coupon && coupon.discountValue && <CouponBomba className="desktop"
                coupon={coupon}
                userId={userId}
                sellerId={sellerId}/>}
            <GigCardListings gigs={gigs}
                gigCollect={gigCollect}
                context={context}
                features={features}
                isTouch={isTouch}
                collectProps={collectProps}/>
        </section>
    );
}

Gigs.propTypes = {
    coupon: shape({
        couponId: string.isRequired,
        couponType: string.isRequired,
        code: string.isRequired,
        discountValue: number.isRequired,
        providerName: string.isRequired
    }),
    gigData: object,
    sellerName: string,
    sellerId: number,
    userId: number,
    currency: object,
    isTouch: bool,
    pageCtxId: string,
    collectProps: object
};
